export default "__VITE_ASSET__ZOpja5a1__"